/* eslint-disable react/jsx-props-no-spreading */
import { Input, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import './NumericInput.css';

const formatNumber = (value) => new Intl.NumberFormat().format(value);

function NumericInput(props) {
  // eslint-disable-next-line react/prop-types
  const { value, onChangeInput } = props;

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      console.log('dentro del if', typeof inputValue);
      onChangeInput(inputValue);
    }
  };

  const title = value ? (
    <span className="numeric-input-title">
      {value !== '-' && value !== '.' ? formatNumber(Number(value)) : 'Ingresar sólo números'}
    </span>
  ) : (
    ''
  );
  // : (
  //   'Ingresar un número'
  // )
  // ;

  return (
    <Tooltip trigger={['focus']} title={title} placement="topLeft" overlayClassName="numeric-input">
      <Input {...props} onChange={handleChange} placeholder="10" maxLength={16} />
    </Tooltip>
  );
}

NumericInput.propTypes = {
  value: PropTypes.string
};

NumericInput.defaultProps = {
  value: ''
};

export default NumericInput;
